import { v4 as generateID } from '@lukeed/uuid';
import { addMissingIDs } from '../utils/addMissingIDs';
import { addMissingShape } from '../utils/addMissingShape';
import { optimizePeaks } from './optimizePeaks';
export function joinBroadPeaks(peakList, options = {}) {
    const { shape = { kind: 'gaussian' }, optimization = { kind: 'lm', options: { timeout: 10 } }, broadWidth = 0.25, broadRatio = 0.0025, } = options;
    let max = 0;
    let maxI = 0;
    let count = 1;
    const broadLines = [];
    if (peakList.length < 2) {
        return addMissingIDs(addMissingShape(peakList.map(getGSDPeakOptimizedStructure), { shape }));
    }
    let maxDdy = peakList[0].ddY;
    for (let i = 1; i < peakList.length; i++) {
        if (Math.abs(peakList[i].ddY) > maxDdy)
            maxDdy = Math.abs(peakList[i].ddY);
    }
    const newPeaks = [];
    for (const peak of peakList) {
        if (Math.abs(peak.ddY) <= broadRatio * maxDdy) {
            broadLines.push(peak);
        }
        else {
            newPeaks.push(getGSDPeakOptimizedStructure(peak));
        }
    }
    //@ts-expect-error Push a feke peak
    broadLines.push({ x: Number.MAX_VALUE, y: 0 });
    let candidates = {
        x: [broadLines[0].x],
        y: [broadLines[0].y],
    };
    let indexes = [0];
    for (let i = 1; i < broadLines.length; i++) {
        if (Math.abs(broadLines[i - 1].x - broadLines[i].x) < broadWidth) {
            candidates.x.push(broadLines[i].x);
            candidates.y.push(broadLines[i].y);
            if (broadLines[i].y > max) {
                max = broadLines[i].y;
                maxI = i;
            }
            indexes.push(i);
            count++;
        }
        else {
            if (count > 2) {
                const fitted = optimizePeaks(candidates, [
                    {
                        id: generateID(),
                        x: broadLines[maxI].x,
                        y: max,
                        width: Math.abs(candidates.x[candidates.x.length - 1] - candidates.x[0]),
                    },
                ], { shape, optimization });
                newPeaks.push(fitted[0]);
            }
            else {
                // Put back the candidates to the peak list
                for (const index of indexes) {
                    newPeaks.push(getGSDPeakOptimizedStructure(broadLines[index]));
                }
            }
            candidates = { x: [broadLines[i].x], y: [broadLines[i].y] };
            indexes = [i];
            max = broadLines[i].y;
            maxI = i;
            count = 1;
        }
    }
    newPeaks.sort((a, b) => {
        return a.x - b.x;
    });
    return addMissingIDs(newPeaks, { output: newPeaks });
}
function getGSDPeakOptimizedStructure(peak) {
    const { id, shape, x, y, width } = peak;
    const newPeak = {
        x,
        y,
        width,
        shape,
    };
    if (id)
        newPeak.id = id;
    return newPeak;
}
//# sourceMappingURL=joinBroadPeaks.js.map